/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FollowZoneMutationVariables = Types.Exact<{
  label_id: Types.Scalars['String'];
}>;


export type FollowZoneMutation = { __typename: 'Mutation', followLabel: { __typename: 'LabelFollow', id: string | null, user_id: string | null, label_id: string | null } | null };


export const FollowZoneDocument = gql`
    mutation followZone($label_id: String!) {
  followLabel(label_id: $label_id) {
    id
    user_id
    label_id
  }
}
    `;
export type FollowZoneMutationFn = Apollo.MutationFunction<FollowZoneMutation, FollowZoneMutationVariables>;

/**
 * __useFollowZoneMutation__
 *
 * To run a mutation, you first call `useFollowZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followZoneMutation, { data, loading, error }] = useFollowZoneMutation({
 *   variables: {
 *      label_id: // value for 'label_id'
 *   },
 * });
 */
export function useFollowZoneMutation(baseOptions?: Apollo.MutationHookOptions<FollowZoneMutation, FollowZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowZoneMutation, FollowZoneMutationVariables>(FollowZoneDocument, options);
      }
export type FollowZoneMutationHookResult = ReturnType<typeof useFollowZoneMutation>;
export type FollowZoneMutationOptions = Apollo.BaseMutationOptions<FollowZoneMutation, FollowZoneMutationVariables>;